"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clear = exports.saveFailure = exports.saveSuccess = exports.saveRequest = exports.remove = exports.move = exports.add = exports.fetchSchemaRequest = exports.schemaActions = void 0;
const ActionTypes = require("../../actionTypes/subproject/schema");
const _metaschemaActions = require("../../modules/metaschema/actions");
exports.schemaActions = _metaschemaActions.default('subproject-schema');
const fetchSchemaRequest = (projectId) => ({
    type: ActionTypes.FETCH_SCHEMA_REQUEST,
    payload: projectId
});
exports.fetchSchemaRequest = fetchSchemaRequest;
const add = (item) => ({
    type: ActionTypes.ADD,
    payload: item
});
exports.add = add;
const move = (item, direction) => ({
    type: ActionTypes.MOVE,
    payload: { item, direction }
});
exports.move = move;
const remove = (item) => ({
    type: ActionTypes.REMOVE,
    payload: item
});
exports.remove = remove;
function saveRequest(schemaId, metas) {
    return {
        type: ActionTypes.SAVE_REQUEST,
        payload: {
            id: schemaId,
            metas
        }
    };
}
exports.saveRequest = saveRequest;
function saveSuccess() {
    return {
        type: ActionTypes.SAVE_SUCCESS
    };
}
exports.saveSuccess = saveSuccess;
function saveFailure(error) {
    return {
        type: ActionTypes.SAVE_FAILURE,
        payload: error
    };
}
exports.saveFailure = saveFailure;
const clear = () => ({
    type: ActionTypes.CLEAR
});
exports.clear = clear;
//# sourceMappingURL=schema.js.map